import { Search } from 'lucide-react';

export const Searchbar = ({ value, onChange }) => {
  return (
    <div
      className="border-2 border-border rounded-md flex flex-row gap-2 px-3.5 py-2 items-center 
             focus-within:border-primary transition-colors"
    >
      <Search size={15} className="text-icon-muted" />
      <input
        type="text"
        placeholder="Search..."
        className="outline-none text-sm w-full bg-transparent text-text"
        value={value}
        onChange={e => onChange(e.target.value)}
      />
    </div>
  );
};
